import { Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { MembershipSavingsBreakdown, MembershipUpgradePreview } from '../types/order.type';

/**
 * Presentational membership savings + upgrade prompt (DEV-10551).
 * Shared by the order summary and the mini-cart; use [compact]="true" in the
 * narrow mini-cart. Emits `upgradeClick` so the host owns the upgrade flow.
 */
@Component({
  selector: 'app-membership-savings',
  imports: [CommonModule, NgbTooltip],
  templateUrl: './membership-savings.component.html',
  styleUrl: './membership-savings.component.scss'
})
export class MembershipSavingsComponent {
  savings = input<number>(0);
  membershipName = input<string | undefined>('');
  breakdown = input<MembershipSavingsBreakdown | null>(null);
  upgrade = input<MembershipUpgradePreview | null>(null);
  isMember = input<boolean>(false);
  /**
   * summary → order page (full). drawer → narrow cart-preview (xs on desktop,
   * roomy on mobile). panel → side-checkout (roomy at all widths).
   */
  variant = input<'summary' | 'drawer' | 'panel'>('summary');

  /** Never name a part worth nothing: "$0.00 in member pricing" tells the
   *  customer nothing, so each half of the breakdown is shown only when it
   *  actually saved money, and the info icon disappears when neither did. */
  showPricingSaving = computed(() => (this.breakdown()?.productPricing ?? 0) > 0);
  showDeliverySaving = computed(() => (this.breakdown()?.delivery ?? 0) > 0);
  showBreakdown = computed(() => this.showPricingSaving() || this.showDeliverySaving());

  upgradeClick = output<void>();
}
